import { render, staticRenderFns } from "./BaseContentLoader.vue?vue&type=template&id=4eff3076&scoped=true"
import script from "./BaseContentLoader.vue?vue&type=script&lang=ts"
export * from "./BaseContentLoader.vue?vue&type=script&lang=ts"
import style0 from "./BaseContentLoader.vue?vue&type=style&index=0&id=4eff3076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@7.1.4_webpack@5.106.2__ejs@3.1.1_13e7c134e45fa6702d5864e7d90f41d2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff3076",
  null
  
)

export default component.exports